import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { AttendanceReportPluckingAndSundry } from './Pages/listing';

export const AttendanceReportPluckingAndSundryRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={AttendanceReportPluckingAndSundry} />
    </Fragment>
)